import { Routes } from "@angular/router";

import { PeriodWatcherLayoutComponent } from "@core/components/period-watcher-layout/period-watcher-layout.component";
import {
    canAuthenticate,
    isAuthenticated,
    isAvailableRoleSimple,
    isMaintenanceMode,
    isNotNewbie,
    periodicUrlMatcher,
} from "@core/constants/guard.constants";
import { PageName } from "@core/enums/defaults.enum";
import { SiteLayoutComponent } from "@core/layouts/site-layout/site-layout.component";

import { MaintenanceComponent } from "./maintenance/maintenance.component";

export const routes: Routes = [
    {
        path: PageName.Maintenance,
        component: MaintenanceComponent,
        canMatch: [isMaintenanceMode],
    },
    {
        path: PageName.Auth,
        loadChildren: () =>
            import("./auth-page/auth.module").then(
                (m: typeof import("./auth-page/auth.module")) => m.AuthModule
            ),
        canMatch: [canAuthenticate],
    },
    {
        path: "",
        component: SiteLayoutComponent,
        canMatch: [isAuthenticated],
        children: [
            {
                path: PageName.Users,
                children: [
                    {
                        path: "",
                        loadChildren: () =>
                            import("./users/users.module").then(
                                (m: typeof import("./users/users.module")) => m.UsersModule
                            ),
                    },
                ],
            },
            {
                path: PageName.Books,
                loadChildren: () => import("./books/books.routes"),
                canMatch: [isNotNewbie],
            },
            {
                path: PageName.Checker,
                loadChildren: () => import("./checker/checker.routes"),
                canMatch: [isNotNewbie],
            },
            {
                path: PageName.Control,
                loadChildren: () =>
                    import("./control/control.routes").then(
                        (m: typeof import("./control/control.routes")) => m.CONTROL_ROUTES
                    ),
                canMatch: [isNotNewbie],
            },
            {
                path: PageName.SubPartners,
                loadChildren: () => import("./sub-partners/sub-partners.routes"),
                canMatch: [isNotNewbie],
            },
            {
                path: PageName.Dressing,
                loadChildren: () => import("./dressing/dressing.routes"),
                canMatch: [isNotNewbie],
            },
            {
                path: PageName.Documents,
                loadChildren: () => import("./documents/documents.routes"),
            },
            {
                path: PageName.Invoice,
                loadChildren: () => import("./invoices/admin/invoices-admin.routes"),
                canMatch: [isAvailableRoleSimple(["admin"])],
            },
            {
                path: PageName.Invoice,
                loadChildren: () => import("./invoices/user/invoice.routes"),
                canMatch: [isNotNewbie],
            },
            {
                path: PageName.Chains,
                loadChildren: () =>
                    import("./chains/chains.module").then(
                        (m: typeof import("./chains/chains.module")) => m.ChainsModule
                    ),
                canMatch: [isNotNewbie],
            },
            {
                path: PageName.Breach,
                loadChildren: () => import("./breach/breach.routes"),
                canMatch: [isNotNewbie],
            },
            {
                path: PageName.Generator,
                loadChildren: () =>
                    import("./generator/generator.module").then(
                        (m: typeof import("./generator/generator.module")) => m.GeneratorModule
                    ),
            },
            {
                matcher: periodicUrlMatcher,
                component: PeriodWatcherLayoutComponent,
            },
            {
                path: "**",
                redirectTo: PageName.Checker,
            },
        ],
    },
];
